<template>
  <div id="the-account-menu">
    <compliance-menu
      :label="$store.state.username"
      :dark-label="darkLabel"
      icon="pic-user"
    >
      <compliance-menu-item
        :label="$t('global.action.disconnect')"
        isList
        @click="logout"
      />
      <compliance-menu-item
        :label="$t('global.pswDialog.changePsw')"
        isList
        @click="changePassword"
      />
      <v-divider class="my-1" />
      <v-list-item>
        <v-btn-toggle
          :value="$store.state.locale"
          mandatory
          dense
          @change="switchLocale"
        >
          <v-btn value="en" small text>EN</v-btn>
          <v-btn value="fr" small text>FR</v-btn>
        </v-btn-toggle>
      </v-list-item>
    </compliance-menu>

    <change-password-dialog v-model="showChangePsw" />
  </div>
</template>

<script>
import { post } from "@/model/api";
import ComplianceMenu from "@/components/ComplianceMenu";
import ComplianceMenuItem from "@/components/ComplianceMenuItem";
import ChangePasswordDialog from "@/components/ChangePasswordDialog";

export default {
  name: "AccountMenu",

  props: {
    darkLabel: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    ComplianceMenu,
    ComplianceMenuItem,
    ChangePasswordDialog,
  },

  data() {
    return {
      showChangePsw: false,
    };
  },

  methods: {
    logout() {
      const kc = this.$store.state.keycloak;
      if (kc) {
        kc.logout({
          redirectUri: window.location.origin,
        });
        return;
      }

      post("/authenticate/logout")
        .then(() => {
          this.$store.commit("clear");
          this.$router.push({ name: "Home" });
        })
        .catch((ex) => {
          this.$store.commit("showError", ex);
          this.$store.commit("clear");
        });
    },

    changePassword() {
      this.showChangePsw = true;
    },

    switchLocale(locale) {
      this.$store.commit("setLocale", {
        locale,
        i18n: this.$root.$i18n,
      });
    },
  },
};
</script>
